import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
 
  {
    id: 'BuyFractions',
    title: 'Buy Fractions',
    translate: 'MENU.PAGES.INVEST',
    type: 'section',
    icon: 'briefcase',
    role: ['Customer'], 
    children: [
      {
        id: 'CommercialResidential',
        title: 'Commercial/Residential',
        icon: 'dollar-sign',
        role: ['Customer'], 
        type: 'collapsible',
        children: [
          {
            id: 'Resorts',
            title: 'Resorts',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/resorts'
          },
          {
            id: 'Hotels',
            title: 'Hotels',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/hotels'
          },
          {
            id: 'Commercial Buildings',
            title: 'Commercial Buildings',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/commercial-building'
          },
          {
            id: 'Shopping Malls',
            title: 'Shopping Malls',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/shoping-malls'
          },]
      },
      {
        id: 'industrial',
        title: 'Industrial',
        icon: 'truck',
        role: ['Customer'], 
        type: 'collapsible',
        children: [
          {
            id: 'warehouses',
            title: 'Warehouses',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/warehouses'
          },
          {
            id: 'FactoryBuildings',
            title: 'Factory Buildings',
            icon: 'circle',
            type: 'item',
            role: ['Customer'], 
            url: 'pages/shop/factory-buildings'
          }
        ]
      },
      {
        id: 'reSelling',
        title: 'Re-Sell',
        type: 'item',
        icon: 'refresh-ccw',
        role: ['Customer'], 
        url: 'pages/re-selling'
      }

    ]
  },
  {
    id: 'listYouAsset',
    title: 'List Your Asset',
    translate: 'MENU.PAGES.CREATE',
    type: 'section',
    role: ['Customer'], 
    icon: 'plus-circle',
    children: [
      {
        id: 'ownAsset',
        title: 'Sell/Lease back Assets',
        type: 'item',
        role: ['Customer'], 
        icon: 'user',
        url: 'pages/blog-list/own-asset'
      },
      {
        id: 'assetToBeAcquired',
        title: 'Asset To Be Acquired',
        type: 'item',
        role: ['Customer'], 
        icon: 'grid',
        url: 'pages/blog-list/asset-to-be-acquired'
      },
      {
        id: 'assetToBeBuilt',
        title: 'Asset To Be Built',
        type: 'item',
        role: ['Customer'], 
        icon: 'codepen',
        url: 'pages/blog-list/asset-to-be-built'
      }
    ]
  },
  {
    id: 'VERIFY',
    title: 'Back Office',
    type: 'section',
    icon: 'shield',
    role: ['Admin'], 
    children: [
      {
        id: 'Verify',
        title: 'Verify',
        type: 'item',
        role: ['Admin'], 
        icon: 'shield',
        url: 'pages/verify'
      },
      {
        id: 'Accountant',
        title: 'Accountant',
        type: 'item',
        role: ['Admin'], 
        icon: 'shield',
        url: 'pages/accountant-verify'
      }
    ]
  },
  {
    id: 'PORTFOLIO',
    title: 'YOUR PORTFOLIO',
    type: 'section',
    icon: 'shield',
    role: ['Customer'], 
    children: [
      {
        id: 'UnitsOwnership',
        title: 'Units Ownership',
        type: 'item',
        role: ['Customer'], 
        icon: 'user',
        url: 'pages/my-portfolio'
      },
      {
        id: 'PortfolioAnalysis',
        title: 'Portfolio Analysis',
        type: 'item',
        role: ['Customer'], 
        icon: 'cpu',
        url: 'pages/Analysis'
      },
      {
        id: 'DocumentVault',
        title: 'Document Vault',
        type: 'item',
        role: ['Customer'], 
        icon: 'lock',
        url: 'pages/Analysis'
      }
    ]
  }
]